import React from 'react';
import StatsGrid from '../molecules/StatsGrid';
import ActivityList from '../molecules/ActivityList';
import './DashboardOverview.css';

interface DashboardStats {
  totalOrders: number;
  processingOrders: number;
  completedOrders: number;
  totalRevenue: number;
}

interface Activity {
  type: 'order' | 'product' | 'customer';
  title: string;
  description: string;
  time: string;
}

interface DashboardOverviewProps {
  stats: DashboardStats;
  activities: Activity[];
}

const DashboardOverview: React.FC<DashboardOverviewProps> = ({ 
  stats, 
  activities 
}) => {
  return (
    <div className="dashboard-overview">
      {/* Stats Section */}
      <div className="overview-section">
        <div className="section-header">
          <h2>Key Metrics</h2>
          <p>Overview of your business performance for the selected period</p>
        </div>
        <StatsGrid stats={stats} />
      </div>

      {/* Recent Activity Section */}
      <div className="overview-section">
        <div className="section-header">
          <h2>Recent Activity</h2>
          <p>Latest orders and updates</p>
        </div>
        <div className="recent-activity-content">
          <ActivityList activities={activities} />
        </div>
      </div>
    </div>
  );
};

export default DashboardOverview;
